import Image from "next/image";
import Link from "next/link";
import { stripImageFromDescription } from "./blogHelpers";
import ReadMoreButton from "./ReadMoreButton";

export default function BlogCard({ post }) {
  const cleanDescription = stripImageFromDescription(post?.description);
 

  return (
    <Link
      href={`/blog/${post?.slug}`}
      className="group flex flex-col p-5 border-r border-b border-gray-200 hover:bg-gray-50 transition-colors h-full"
    >
      {/* Thumbnail */}
      <div className="relative w-full aspect-[3/2] overflow-hidden rounded-lg bg-gray-200 mb-4">
        {post?.image && (
          <Image
            alt={post.title || "Blog post image"}
            src={post.image}
            title={post.title || "Blog post image"}
            fill
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
            className="object-cover"
            loading="eager"
          />
        )}
      </div>

      {/* Title */}
      <h3 className="text-base font-[600] leading-snug text-[#090C1D] mb-2 line-clamp-2">
        {post?.title || "Untitled Post"}
      </h3>

      {/* Description */}
      {cleanDescription && (
        <div
          dangerouslySetInnerHTML={{ __html: cleanDescription }}
          className="  text-xs  md:text-sm [&_*]:text-[#646464] leading-relaxed line-clamp-2 mb-5"
        />
      )}

      {/* Read more */}
      <div>
        <ReadMoreButton />
      </div>
    </Link>
  );
}
